function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("title", null, "close");
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Desktop-view",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-Home-screen---Profile-screen",
  transform: "translate(-1321.000000, -127.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1330.45115,137.937503 C1330.6061,137.937503 1330.72784,137.882164 1330.81638,137.771487 L1330.81638,137.771487 L1331.64646,136.941411 C1331.75714,136.85287 1331.81247,136.731125 1331.81247,136.576178 C1331.81247,136.42123 1331.75714,136.299486 1331.64646,136.210944 L1331.64646,136.210944 L1328.09373,132.625015 L1331.64646,129.039086 C1331.75714,128.950545 1331.81247,128.8288 1331.81247,128.673853 C1331.81247,128.518905 1331.75714,128.397161 1331.64646,128.308619 L1331.64646,128.308619 L1330.81638,127.478543 C1330.72784,127.367866 1330.6061,127.312528 1330.45115,127.312528 C1330.2962,127.312528 1330.17446,127.367866 1330.08592,127.478543 L1330.08592,127.478543 L1326.49999,131.031269 L1322.91406,127.478543 C1322.82552,127.367866 1322.70377,127.312528 1322.54882,127.312528 C1322.39388,127.312528 1322.27213,127.367866 1322.18359,127.478543 L1322.18359,127.478543 L1321.35352,128.308619 C1321.24284,128.397161 1321.1875,128.518905 1321.1875,128.673853 C1321.1875,128.8288 1321.24284,128.950545 1321.35352,129.039086 L1321.35352,129.039086 L1324.90624,132.625015 L1321.35352,136.210944 C1321.24284,136.299486 1321.1875,136.42123 1321.1875,136.576178 C1321.1875,136.731125 1321.24284,136.85287 1321.35352,136.941411 L1321.35352,136.941411 L1322.18359,137.771487 C1322.27213,137.882164 1322.39388,137.937503 1322.54882,137.937503 C1322.70377,137.937503 1322.82552,137.882164 1322.91406,137.771487 L1322.91406,137.771487 L1326.49999,134.218761 L1330.08592,137.771487 C1330.17446,137.882164 1330.2962,137.937503 1330.45115,137.937503 Z",
  id: "close"
})));
const SvgClose = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.4f1507ff.svg";
export { ForwardRef as ReactComponent };